<template>
  <div class="progressM">
    <el-row>
      <el-col :span="12">
        <el-row>
          <el-col :span="6">
            <div class="totalProgress">{{totalProgress}}%</div>
            <div class="totalTitle">总体工程进度</div>
          </el-col>
          <el-col :span="5" v-show="liquidfill.wave1">
            <div class="wave-echart" id="waveEchart1" ref="waveEchart1"></div>
            <div class="waveLayer">
              {{ isType == "lq" ? "上面层" : "上基层" }}
            </div>
            <div class="waveProgress">{{(liquidfill.wave1*100).toFixed(2)}}%</div>
          </el-col>
          <el-col :span="5" v-show="liquidfill.wave2">
            <div class="wave-echart" id="waveEchart2" ref="waveEchart2"></div>
            <div class="waveLayer">
              {{ isType == "lq" ? "中面层" : "下基层" }}
            </div>
            <div class="waveProgress">{{(liquidfill.wave2*100).toFixed(2)}}%</div>
          </el-col>
          <el-col :span="5" v-show="liquidfill.wave3">
            <div class="wave-echart" id="waveEchart3" ref="waveEchart3"></div>
            <div class="waveLayer">
              {{ isType == "lq" ? "下面层" : "底基层" }}
            </div>
            <div class="waveProgress">{{(liquidfill.wave3*100).toFixed(2)}}%</div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="12">
        <el-row>
          <el-col :span="6">
            <div class="totalProgress">{{sectionProgress}}%</div>
            <div class="totalTitle">{{ sectionName?sectionName:'无标段' }}</div>
          </el-col>
          <el-col :span="5" v-show="liquidfill.wave4">
            <div class="wave-echart" id="waveEchart4" ref="waveEchart4"></div>
            <div class="waveLayer">
              {{ isType == "lq" ? "上面层" : "上基层" }}
            </div>
            <div class="waveProgress">{{(liquidfill.wave4*100).toFixed(2)}}%</div>
          </el-col>
          <el-col :span="5" v-show="liquidfill.wave5">
            <div class="wave-echart" id="waveEchart5" ref="waveEchart5"></div>
            <div class="waveLayer">
              {{ isType == "lq" ? "中面层" : "下基层" }}
            </div>
            <div class="waveProgress">{{(liquidfill.wave5*100).toFixed(2)}}%</div>
          </el-col>
          <el-col :span="5" v-show="liquidfill.wave6">
            <div class="wave-echart" id="waveEchart6" ref="waveEchart6"></div>
            <div class="waveLayer">
              {{ isType == "lq" ? "下面层" : "底基层" }}
            </div>
            <div class="waveProgress">{{(liquidfill.wave6*100).toFixed(2)}}%</div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { getProgressInfo } from "@/api/api";
import { mapState } from "vuex";
import echartsLiquidfill from "echarts-liquidfill";
export default {
  props: {
    type: ""
  },
  data() {
    return {
      sectionName: "",
      isType: "",
      totalProgress:"",
      sectionProgress:"",
      liquidfill: {
        wave1: 0,
        wave2: 0,
        wave3: 0,
        wave4: 0,
        wave5: 0,
        wave6: 0
      }
    };
  },
  created() {
    this.dataRefreh();
  },
  mounted() {
    this.isType = this.type;
      // console.log(this.seIds)
  },
  beforeDestroy() {
    this.clear();
  },
  methods: {
    // 定时刷新数据函数
    dataRefreh() {
      // 计时器正在进行中，退出函数
      if (this.intervalId != null) {
        return;
      }
      // 计时器为空，操作
      this.intervalId = setInterval(() => {
        this.getProgress()
      }, 5000);
    },
    // 停止定时器
    clear() {
      clearInterval(this.intervalId); //清除计时器
      this.intervalId = null; //设置为null
    },
    async getProgress() {
      if(this.sectionId) {
        let req = {
        engineerId: this.engineerId,
        sectionId: this.seIds,
        workAreaId:this.sectionId
      };
      const gpData = await getProgressInfo(req);
     if(gpData.status == 200) {
        this.sectionName = gpData.data.sectionList[0].length!=0?gpData.data.sectionList[0].name:''
       this.totalProgress = gpData.data.totalPercent
      this.sectionProgress = gpData.data.sectionList[0].totalPercent
     }
      
      if (this.isType == "lq") {
        this.liquidfill = {
          wave1:
            gpData.data.layers.filter(item => item.key.indexOf("上面") >= 0)
              .length > 0
              ? gpData.data.layers.filter(
                  item => item.key.indexOf("上面") >= 0
                )[0].value/100
              : 0,
          wave2:
            gpData.data.layers.filter(item => item.key.indexOf("中面") >= 0)
              .length > 0
              ? gpData.data.layers.filter(
                  item => item.key.indexOf("中面") >= 0
                )[0].value/100
              : 0,
          wave3:
            gpData.data.layers.filter(item => item.key.indexOf("下面") >= 0)
              .length > 0
              ? gpData.data.layers.filter(
                  item => item.key.indexOf("下面") >= 0
                )[0].value/100
              : 0,
          wave4:
            gpData.data.sectionList[0].layers.filter(
              item => item.key.indexOf("上面") >= 0
            ).length > 0
              ? gpData.data.sectionList[0].layers.filter(
                  item => item.key.indexOf("上面") >= 0
                )[0].value/100
              : 0,
          wave5:
            gpData.data.sectionList[0].layers.filter(
              item => item.key.indexOf("中面") >= 0
            ).length > 0
              ? gpData.data.sectionList[0].layers.filter(
                  item => item.key.indexOf("中面") >= 0
                )[0].value/100
              : 0,
          wave6:
            gpData.data.sectionList[0].layers.filter(
              item => item.key.indexOf("下面") >= 0
            ).length > 0
              ? gpData.data.sectionList[0].layers.filter(
                  item => item.key.indexOf("下面") >= 0
                )[0].value/100
              : 0
        };
        console.log(this.liquidfill)
      } else {
        this.liquidfill = {
          wave1:
            gpData.data.layers.filter(item => item.key.indexOf("上基") >= 0)
              .length > 0
              ? gpData.data.layers.filter(
                  item => item.key.indexOf("上基") >= 0
                )[0].value/100
              : 0,
          wave2:
            gpData.data.layers.filter(item => item.key.indexOf("下基") >= 0)
              .length > 0
              ? gpData.data.layers.filter(
                  item => item.key.indexOf("下基") >= 0
                )[0].value/100
              : 0,
          wave3:
            gpData.data.layers.filter(item => item.key.indexOf("底基") >= 0)
              .length > 0
              ? gpData.data.layers.filter(
                  item => item.key.indexOf("底基") >= 0
                )[0].value/100
              : 0,
          wave4:
            gpData.data.sectionList[0].layers.filter(
              item => item.key.indexOf("上基") >= 0
            ).length > 0
              ? gpData.data.sectionList[0].layers.filter(
                  item => item.key.indexOf("上基") >= 0
                )[0].value/100
              : 0,
          wave5:
            gpData.data.sectionList[0].layers.filter(
              item => item.key.indexOf("下基") >= 0
            ).length > 0
              ? gpData.data.sectionList[0].layers.filter(
                  item => item.key.indexOf("下基") >= 0
                )[0].value/100
              : 0,
          wave6:
            gpData.data.sectionList[0].layers.filter(
              item => item.key.indexOf("底基") >= 0
            ).length > 0
              ? gpData.data.sectionList[0].layers.filter(
                  item => item.key.indexOf("底基") >= 0
                )[0].value/100
              : 0
        };
      }
      console.log(this.liquidfill.wave1)
      }else {
        this.liquidfill= {
        wave1: 0,
        wave2: 0,
        wave3: 0,
        wave4: 0,
        wave5: 0,
        wave6: 0
      }
      this.totalProgress = 0
      this.sectionProgress = 0
      }
       this.initWave()
    },
    initWave(ref) {
      let _this = this;
      setTimeout(() => {
        // waveEchart1
        _this.chart = this.$echarts.init(
          document.getElementById("waveEchart1")
        );
        // 把配置和数据放这里
        _this.chart.setOption({
          title: {
            // 标题
            text: "",
            textStyle: {
              // 标题的样式
              color: "#888", // 字体颜色
              fontFamily: "Microsoft YaHei", // 字体
              fontSize: 14,
              fontWeight: "400",
              align: "center", // 文字的水平方式
              baseline: "middle",
              position: "inside",
              verticalAlign: "middle" // 文字的垂直方式
            },
            left: "center", // 定位
            top: "20%"
          },
          series: [
            {
              type: "liquidFill",
              radius: "95%",
              waveAnimation: true,
              data: [
                {
                  value: this.liquidfill.wave1,
                  direction: "left",
                  itemStyle: {
                    normal: {
                      color: "#ffa800"
                      // #6245fe
                      // #fc5a52
                    }
                  }
                }
              ],
              outline: {
                // show: true , //是否显示轮廓 布尔值
                borderDistance: 1, // 外部轮廓与图表的距离 数字
                itemStyle: {
                  borderColor: "#ffa800", // 边框的颜色
                  borderWidth: 2 // 边框的宽度
                  // shadowBlur: 5 , //外部轮廓的阴影范围 一旦设置了内外都有阴影
                  // shadowColor: '#000' //外部轮廓的阴影颜色
                }
              },
              itemStyle: {
                opacity: 0.9, // 波浪的透明度
                shadowBlur: 0 // 波浪的阴影范围
              },
              backgroundStyle: {
                color: "#fff" // 图表的背景颜色
              },
              label: {
                // 数据展示样式
                show: false,
                color: "#000",
                insideColor: "#fff",
                fontSize: 20,
                fontWeight: 400,
                align: "center",
                baseline: "middle",
                position: "inside"
              }
            }
          ]
        });
        // waveEchart2
        _this.chart = this.$echarts.init(
          document.getElementById("waveEchart2")
        );
        _this.chart.setOption({
          series: [
            {
              type: "liquidFill",
              radius: "95%",
              waveAnimation: true,
              data: [
                {
                  value: this.liquidfill.wave2,
                  direction: "left",
                  itemStyle: {
                    normal: {
                      color: "#6245fe"
                    }
                  }
                }
              ],
              outline: {
                borderDistance: 1,
                itemStyle: {
                  borderColor: "#6245fe",
                  borderWidth: 2
                }
              },
              itemStyle: {
                opacity: 0.9,
                shadowBlur: 0
              },
              backgroundStyle: {
                color: "#fff"
              },
              label: {
                show: false,
                color: "#000",
                insideColor: "#fff",
                fontSize: 20,
                fontWeight: 400,
                align: "center",
                baseline: "middle",
                position: "inside"
              }
            }
          ]
        });
        // waveEchart3
        _this.chart = this.$echarts.init(
          document.getElementById("waveEchart3")
        );
        _this.chart.setOption({
          series: [
            {
              type: "liquidFill",
              radius: "95%",
              waveAnimation: true,
              data: [
                {
                  value: this.liquidfill.wave3,
                  direction: "left",
                  itemStyle: {
                    normal: {
                      color: "#fc5a52"
                    }
                  }
                }
              ],
              outline: {
                borderDistance: 1,
                itemStyle: {
                  borderColor: "#fc5a52",
                  borderWidth: 2
                }
              },
              itemStyle: {
                opacity: 0.9,
                shadowBlur: 0
              },
              backgroundStyle: {
                color: "#fff"
              },
              label: {
                show: false,
                color: "#000",
                insideColor: "#fff",
                fontSize: 20,
                fontWeight: 400,
                align: "center",
                baseline: "middle",
                position: "inside"
              }
            }
          ]
        });
        // waveEchart4
        _this.chart = this.$echarts.init(
          document.getElementById("waveEchart4")
        );
        _this.chart.setOption({
          series: [
            {
              type: "liquidFill",
              radius: "95%",
              waveAnimation: true,
              data: [
                {
                  value: this.liquidfill.wave4,
                  direction: "left",
                  itemStyle: {
                    normal: {
                      color: "#ffa800"
                    }
                  }
                }
              ],
              outline: {
                borderDistance: 1,
                itemStyle: {
                  borderColor: "#ffa800",
                  borderWidth: 2
                }
              },
              itemStyle: {
                opacity: 0.9,
                shadowBlur: 0
              },
              backgroundStyle: {
                color: "#fff"
              },
              label: {
                show: false,
                color: "#000",
                insideColor: "#fff",
                fontSize: 20,
                fontWeight: 400,
                align: "center",
                baseline: "middle",
                position: "inside"
              }
            }
          ]
        });
        // waveEchart5
        _this.chart = this.$echarts.init(
          document.getElementById("waveEchart5")
        );
        _this.chart.setOption({
          series: [
            {
              type: "liquidFill",
              radius: "95%",
              waveAnimation: true,
              data: [
                {
                  value: this.liquidfill.wave5,
                  direction: "left",
                  itemStyle: {
                    normal: {
                      color: "#6245fe"
                    }
                  }
                }
              ],
              outline: {
                borderDistance: 1,
                itemStyle: {
                  borderColor: "#6245fe",
                  borderWidth: 2
                }
              },
              itemStyle: {
                opacity: 0.9,
                shadowBlur: 0
              },
              backgroundStyle: {
                color: "#fff"
              },
              label: {
                show: false,
                color: "#000",
                insideColor: "#fff",
                fontSize: 20,
                fontWeight: 400,
                align: "center",
                baseline: "middle",
                position: "inside"
              }
            }
          ]
        });
        // waveEchart6
        _this.chart = this.$echarts.init(
          // this.$refs.waveEchart6
          document.getElementById("waveEchart6")
        );
        _this.chart.setOption({
          series: [
            {
              type: "liquidFill",
              radius: "95%",
              waveAnimation: true,
              data: [
                {
                  value: this.liquidfill.wave6,
                  direction: "left",
                  itemStyle: {
                    normal: {
                      color: "#fc5a52"
                    }
                  }
                }
              ],
              outline: {
                borderDistance: 1,
                itemStyle: {
                  borderColor: "#fc5a52",
                  borderWidth: 2
                }
              },
              itemStyle: {
                opacity: 0.9,
                shadowBlur: 0
              },
              backgroundStyle: {
                color: "#fff"
              },
              label: {
                show: false,
                color: "#000",
                insideColor: "#fff",
                fontSize: 20,
                fontWeight: 400,
                align: "center",
                baseline: "middle",
                position: "inside"
              }
            }
          ]
        });
      }, 0);
    }
  },
  computed: mapState(["engineerId", "sectionId", "workAreaId", "seIds"]),
  watch: {
    // engineerId(curVal, oldVal) {
    //   //这里的curVal就是需要监听的值
    //   this.getInfo();
    // },
    isType(curVal, oldVal) {
      // this.sectionName = sessionStorage.getItem("sectionName");
      window.setTimeout(() => {
        this.getProgress();
      }, 800);
    },
    sectionId(curVal, oldVal) {
      // this.sectionName = sessionStorage.getItem("sectionName");
      this.getProgress();
    },
    workAreaId(curVal, oldVal) {}
  }
};
</script>

<style lang="less" scoped>
.progressM {
  position: absolute;
  height: 100%;
  width: 100%;
  .el-row {
    height: 100%;
    .el-col-12,
    .el-col-6,
    .el-col-5 {
      height: 100%;
    }
  }
  .totalProgress {
    text-align: center;
    width: 100%;
    height: 48px;
    margin-top: 30px;
    font-size: 26px;
    font-family: DIN;
    font-weight: bold;
    color: #fff721;
    line-height: 26px;
  }
  .totalTitle {
    width: 100%;
    padding: 0 5px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: center;
    height: 24px;
    line-height: 24px;
    background: rgba(0, 0, 0, 0.3);
    color: #fff;
    font-size: 14px;
    border-radius: 12px;
  }
  .wave-echart {
    margin: 0 auto;
    margin-top: 20px;
    width: 55px;
    height: 55px;
  }
  .waveLayer {
    width: 100%;
    text-align: center;
    height: 21px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 21px;
    margin-top: 2px;
  }
  .waveProgress {
    width: 100%;
    text-align: center;
    height: 12px;
    font-size: 16px;
    font-family: DIN;
    font-weight: bold;
    color: #44f8ff;
    line-height: 21px;
  }
}
</style>



// WEBPACK FOOTER //
// src/subassembly/progress.vue